export default __webpack_public_path__ + "static/media/homepage.1a1d0257.webp";